import React, {ReactNode} from 'react';

import withStyles, {WithStyles} from '@material-ui/core/styles/withStyles';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';

import {styles} from './styles';

export type ListProps<T extends Item = Item> = WithStyles<typeof styles> & {
  items: ItemProps<T>['item'][];
  children?: ItemProps<T>['children'];
};

type Item = {value?: string; label: string; disabledDrag?: boolean};
type ItemProps<T extends Item = Item> = {
  item: T;
  sortIndex: number;
  children?: (props: {item: T; sortIndex: number}) => ReactNode;
};
const ChildrenItem = ({item, sortIndex, children}: ItemProps) => {
  return <>{children({item, sortIndex})}</>;
};
const SortableItem = SortableElement(ChildrenItem);

const List = <T extends Item>(props: ListProps<T>) => {
  const {classes, items, children} = props;

  return (
    <div className={classes.root}>
      {items &&
        items.map((item, index) => {
          return (
            <SortableItem
              key={`${item.value}_${index}`}
              item={item}
              index={index}
              sortIndex={index}
              disabled={item.disabledDrag}
            >
              {children}
            </SortableItem>
          );
        })}
    </div>
  );
};

export default withStyles(styles)(SortableContainer(List));
